import React, { Dispatch, SetStateAction } from "react";
import styles from "./KundliItems.module.scss";
import { kundliDataType, UserAstroProfile } from "../../Enum";
import Image from "next/image";
import { Images } from "@/utils/constants/imageRelativePaths";
import { useRouter } from "next/navigation";
import { FormResponse } from "@/types/common.types";

interface KundliItemsProps {
  userGender: string;
  items: UserAstroProfile[];
  setPopUp: React.Dispatch<React.SetStateAction<boolean>>;
  setItemToRemove: Dispatch<SetStateAction<number>>;
  onProfileSelect: (data: FormResponse) => void;
}

const KundliItems = ({
  userGender,
  items,
  setPopUp,
  setItemToRemove,
  onProfileSelect,
}: KundliItemsProps) => {
  const router = useRouter();

  const handleConfirmDelete = (id: number) => {
    setItemToRemove(id);
    setPopUp(true);
  };

  const onProfileClick = (profile: UserAstroProfile) => {
    onProfileSelect({
      name: (profile?.firstName ?? "") + " " + (profile?.lastName ?? ""),
      DOB: profile?.dob ?? "1998-01-20",
      time_of_birth: profile?.tob?.slice(0, 5),
      place_of_birth: profile?.pob,
      gender:profile.gender,
    });
  };

  return (
    <ul className={styles.listWrapper}>
      {items.map((profile) => {
        const { id, firstName, lastName, dob, tob, pob, gender } = profile;
        // if (gender !== userGender && userGender !== "") return null;
        return (
          <li
            className={styles.kundliItem}
            key={id}
            onClick={() => onProfileClick(profile)}
          >
            <div className={styles.contentWrapper}>
              <div className={styles.lettersWrapper}>
                {firstName.toUpperCase().trim().slice(0, 1)}
              </div>
              <div className={styles.textWrapper}>
                <h3>
                  {firstName} {lastName} <span>({gender})</span>
                </h3>
                <p>
                  {tob} , {dob}
                </p>
                <p>{pob}</p>
              </div>
            </div>
            <div className={styles.iconsWrapper}>
              <Image
                src={Images.delete}
                alt="delete"
                height={20}
                width={20}
                onClick={(e) => {
                  e.stopPropagation();
                  handleConfirmDelete(id);
                }}
              />
              {/* <Image
                  src={Images.pencil}
                  alt="pencil"
                  height={20}
                  width={20}
                  onClick={() => handleEdit(id)}
                /> */}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default KundliItems;
